// import React, { useEffect, useState } from "react";
// import { Card, Row, Table } from "react-bootstrap";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import { Oval } from "react-loader-spinner";
// import { webServiceUrl } from "../../../components/apiCall/webserviceurl";

// const formatDate = (dateStr) => {
//   if (!dateStr) return "";
//   const d = new Date(dateStr);
//   const day = d.getDate().toString().padStart(2, "0");
//   const month = d.toLocaleString("default", { month: "long" });
//   const year = d.getFullYear();
//   return `${day}-${month}-${year}`;
// };

// /**
//  * LessonPlanSection
//  * Self-contained Lesson Plan card: fetches the list of training days for the
//  * course, lets the student switch between days via a dropdown, and loads the
//  * lesson plan rows for whichever day is selected. Fully API-driven — reads
//  * `course` from the session the same way the rest of the app does.
//  *
//  * Usage:
//  *   <LessonPlanSection />
//  */
// const LessonPlanSection = () => {
//   const location = useLocation();
//   const course =
//     JSON.parse(localStorage.getItem("course")) ?? location.state?.course;
//   const courseData = course?.student;

//   const [days, setDays] = useState([]);
//   const [selectedDay, setSelectedDay] = useState("");
//   const [lessonPlans, setLessonPlans] = useState([]);
//   const [isDaysLoading, setIsDaysLoading] = useState(true);
//   const [isLessonLoading, setIsLessonLoading] = useState(true);

//   const handleChange = (event) => {
//     setSelectedDay(event.target.value);
//   };

//   const getDays = async () => {
//     try {
//       setIsDaysLoading(true);
//       const response = await axios.post(webServiceUrl.getLessonPlanDays, {
//         school_code: course?.school_code,
//         class_name: courseData?.class,
//         section: courseData?.section,
//         level: courseData?.level,
//         combination_code: courseData?.combination_code,
//       });

//       const data = response?.data?.data ?? [];
//       setDays(data);
//       if (data.length > 0) {
//         setSelectedDay(data[0].day);
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setIsDaysLoading(false);
//     }
//   };

//   const getLessonPlans = async () => {
//     if (!selectedDay) return;
//     try {
//       setIsLessonLoading(true);
//       const response = await axios.post(webServiceUrl.lesson_plan, {
//         school_code: course?.school_code,
//         class_name: courseData?.class,
//         section: courseData?.section,
//         level: courseData?.level,
//         combination_code: courseData?.combination_code,
//         planned_on: selectedDay,
//       });

//       setLessonPlans(response?.data?.data ?? []);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setTimeout(() => setIsLessonLoading(false), 800);
//     }
//   };

//   useEffect(() => {
//     getDays();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     getLessonPlans();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedDay]);

//   return (
//     <Card>
//       <Card.Header>
//         <div className="card-header-toolbar d-flex align-items-center"></div>
//       </Card.Header>

//       <Card.Body className="pt-0">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           {!isDaysLoading && days.length > 0 && (
//             <select
//               id="feedback"
//               className="form-select w-25"
//               value={selectedDay}
//               onChange={handleChange}
//             >
//               {days.map((d, index) => (
//                 <option key={index} value={d.day}>
//                   {`Day ${index + 1} \u00A0\u00A0\u00A0\u00A0   ${formatDate(d.day)}`}
//                 </option>
//               ))}
//             </select>
//           )}
//         </div>

//         {/* <> */}
//           <div className="table-wrapper mt-4">
//             <div className="table-scroll">
//               <Table striped bordered hover className="custom-table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Unit</th>
//                     <th>Topic</th>
//                     <th>Description</th>
//                     <th>Start Time</th>
//                     <th>End Time</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {isLessonLoading || isDaysLoading ? (
//                     <tr>
//                       <td colSpan="6" className="border-0">
//                         <div className="d-flex justify-content-center pt-3 pb-2">
//                           <Oval
//                             height="50"
//                             width="50"
//                             color="#4fa94d"
//                             secondaryColor="#4fa94d"
//                           />
//                         </div>
//                       </td>
//                     </tr>
//                   ) : lessonPlans.length > 0 ? (
//                     lessonPlans.map((file, index) => (
//                       <tr key={index}>
//                         <td>{formatDate(file?.planned_on)}</td>
//                         <td>{file?.unit}</td>
//                         <td>{file?.topic}</td>
//                         <td>{file?.description}</td>
//                         <td>{file?.start_time?.slice(0, 5)}</td>
//                         <td>{file?.end_time?.slice(0, 5)}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="6" className="text-center text-muted">
//                         No files found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </Table>
//             </div>
//           </div>
//         {/* </Row> */}
//       </Card.Body>
//     </Card>
//   );
// };

// export default LessonPlanSection;

import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Oval } from "react-loader-spinner";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = d.getDate().toString().padStart(2, "0");
  const month = d.toLocaleString("default", { month: "long" });
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
};

const formatShortDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = d.getDate().toString().padStart(2, "0");
  const month = d.toLocaleString("default", { month: "short" });
  return `${day} ${month}`;
};

const formatWeekday = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleString("default", { weekday: "short" });
};

const initials = (unit) => {
  if (!unit) return "—";
  const words = unit.trim().split(/\s+/).slice(0, 2);
  return words.map((w) => w[0]?.toUpperCase()).join("");
};

/**
 * LessonPlanSection
 * Self-contained Lesson Plan card: fetches the list of training days for the
 * course, lets the student switch between days via a horizontal day rail,
 * and loads the lesson plan entries for whichever day is selected as a
 * vertical class-by-class timeline. Fully API-driven — reads `course` from
 * the session the same way the rest of the app does.
 *
 * Usage:
 *   <LessonPlanSection />
 */
const LessonPlanSection = () => {
  const location = useLocation();
  // const course =
  //   JSON.parse(localStorage.getItem("course"))[0] ?? location.state?.course;
  const [course, setcourse] = useState();
  const courseData = course?.student;

  const users = JSON.parse(localStorage.getItem("users"));

  const [days, setDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState("");
  const [lessonPlans, setLessonPlans] = useState([]);
  const [isDaysLoading, setIsDaysLoading] = useState(true);
  const [isLessonLoading, setIsLessonLoading] = useState(true);
  const railRef = useRef(null);

  const getEnrolledCourses = async () => {
    try {
      const response = await axios.post(webServiceUrl.enrolledCourses, {
        users,
      });
      setcourse(response.data.enrolledCourses[0]);
      await localStorage.setItem(
        "course",
        JSON.stringify(response.data.enrolledCourse[0]),
      );
      // NOTE: removed the getLessonPlans() call from here — at this point
      // selectedDay is still "" (state hasn't been set yet), so it was a
      // silent no-op every time. Lesson plans are now fetched by the
      // dedicated useEffect below whenever selectedDay actually changes.
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getEnrolledCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // <-- was [getEnrolledCourses], which re-creates every render and
  // was re-firing the effect on every render. Empty array = run once on mount.se

  const getDays = async () => {
    try {
      setIsDaysLoading(true);
      const response = await axios.post(webServiceUrl.getLessonPlanDays, {
        school_code: course?.school_code,
        class_name: courseData?.class,
        section: courseData?.section,
        level: courseData?.level,
        combination_code: courseData?.combination_code,
      });

      const data = response?.data?.data ?? [];
      setDays(data);
      if (data.length > 0) {
  
        setSelectedDay(data[0].day);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsDaysLoading(false);
    }
  };

  const getLessonPlans = async () => {
    if (!selectedDay) return;
    try {
      setIsLessonLoading(true);
      const response = await axios.post(webServiceUrl.lesson_plan, {
        school_code: course?.school_code,
        class_name: courseData?.class,
        section: courseData?.section,
        level: courseData?.level,
        combination_code: courseData?.combination_code,
        planned_on: selectedDay,
      });

      setLessonPlans(response?.data?.data ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => setIsLessonLoading(false), 500);
    }
  };

  console.log(course);
  
// 2. When course arrives -> load available days
useEffect(() => {
  
    getDays();
  
}, [course]);

// 3. When a day is selected -> load lesson plan
useEffect(() => {
  if (selectedDay) {
    getLessonPlans();
  }
}, [selectedDay]);

  const scrollRail = (dir) => {
    if (railRef.current) {
      railRef.current.scrollBy({ left: dir * 160, behavior: "smooth" });
    }
  };

  const selectedMeta = days.find((d) => d.day === selectedDay);

  return (
    <Card className="lp-card">
      <style>{`
        .lp-card {
          --lp-ink: #1F2430;
          --lp-muted: #767186;
          --lp-bg: #FAF9F6;
          --lp-line: #E7E3DA;
          --lp-navy: #2C3454;
          --lp-amber: #E8A33D;
          --lp-amber-soft: #FBEBD2;
          --lp-teal: #4F7C6E;
          --lp-teal-soft: #E3EEE9;
          border: none;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 2px 18px rgba(44, 52, 84, 0.08);
          background: #fff;
        }
        .lp-header {
          background:#16a34a;
          padding: 20px 24px;
          display: flex;
          align-items: baseline;
          justify-content: space-between;
        }
        .lp-header-title {
          color: #fff;
          font-size: 17px;
          font-weight: 700;
          letter-spacing: 0.2px;
          margin: 0;
        }
        .lp-header-sub {
          color: rgba(255,255,255,0.68);
          font-size: 12.5px;
          margin: 0;
        }
        .lp-body {
          background: var(--lp-bg);
          padding: 20px;
        }
        .lp-rail-wrap {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 22px;
        }
        .lp-rail-btn {
          flex: 0 0 auto;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 1px solid var(--lp-line);
          background: #fff;
          color:#16a34a;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 13px;
          line-height: 1;
          user-select: none;
        }
        .lp-rail-btn:hover { background: var(--lp-amber-soft); border-color: var(--lp-amber); }
        .lp-rail {
          display: flex;
          gap: 10px;
          overflow-x: auto;
          scroll-behavior: smooth;
          padding: 4px 2px;
          scrollbar-width: none;
        }
        .lp-rail::-webkit-scrollbar { display: none; }
        .lp-day-chip {
          flex: 0 0 auto;
          min-width: 84px;
          padding: 8px 14px;
          border-radius: 12px;
          border: 1px solid var(--lp-line);
          background: #fff;
          text-align: center;
          cursor: pointer;
          transition: all 0.15s ease;
        }
        .lp-day-chip:hover { border-color: var(--lp-amber); }
        .lp-day-chip.active {
          background:#16a34a;
          border-color:#16a34a;
        }
        .lp-day-chip-label {
          font-size: 10.5px;
          font-weight: 700;
          letter-spacing: 0.6px;
          text-transform: uppercase;
          color: var(--lp-muted);
        }
        .lp-day-chip.active .lp-day-chip-label { color: rgba(255,255,255,0.65); }
        .lp-day-chip-date {
          font-size: 14px;
          font-weight: 700;
          color: var(--lp-ink);
          margin-top: 2px;
        }
        .lp-day-chip.active .lp-day-chip-date { color: #fff; }

        .lp-timeline { position: relative; padding-left: 4px; }
        .lp-entry {
          display: flex;
          gap: 16px;
          position: relative;
          padding-bottom: 22px;
        }
        .lp-entry:last-child { padding-bottom: 4px; }
        .lp-time-col {
          flex: 0 0 64px;
          text-align: right;
          padding-top: 2px;
        }
        .lp-time-start {
          font-size: 13px;
          font-weight: 700;
          color:#16a34a;
        }
        .lp-time-end {
          font-size: 11px;
          color: var(--lp-muted);
        }
        .lp-rail-col {
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .lp-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: var(--lp-amber);
          margin-top: 4px;
          flex: 0 0 auto;
        }
        .lp-dot-line {
          width: 2px;
          flex: 1 1 auto;
          background: var(--lp-line);
          margin-top: 2px;
        }
        .lp-entry:last-child .lp-dot-line { background: transparent; }
        .lp-entry-card {
          flex: 1 1 auto;
          background: #fff;
          border: 1px solid var(--lp-line);
          border-radius: 12px;
          padding: 14px 16px;
        }
        .lp-entry-top {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 6px;
        }
        .lp-unit-badge {
          flex: 0 0 auto;
          width: 30px;
          height: 30px;
          border-radius: 8px;
          background: var(--lp-teal-soft);
          color: var(--lp-teal);
          font-size: 11px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .lp-topic {
          font-size: 14.5px;
          font-weight: 700;
          color: var(--lp-ink);
        }
        .lp-unit {
          font-size: 11.5px;
          color: var(--lp-muted);
          font-weight: 600;
        }
        .lp-description {
          font-size: 13px;
          color: #4A4658;
          line-height: 1.5;
          margin: 0;
          padding-left: 40px;
        }

        .lp-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 48px 16px;
          text-align: center;
        }
        .lp-empty-icon {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: var(--lp-amber-soft);
          color: var(--lp-amber);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          margin-bottom: 12px;
        }
        .lp-empty-title {
          font-size: 14px;
          font-weight: 700;
          color: var(--lp-ink);
          margin: 0 0 2px;
        }
        .lp-empty-sub {
          font-size: 12.5px;
          color: var(--lp-muted);
          margin: 0;
        }
      `}</style>

      <div className="lp-header">
        <p className="lp-header-title">Lesson Plan</p>
        {selectedMeta && (
          <p className="lp-header-sub">{formatDate(selectedMeta.day)}</p>
        )}
      </div>

      <div className="lp-body">
        {isDaysLoading ? (
          <div className="lp-state" style={{ padding: "24px 16px" }}>
            <Oval
              height="36"
              width="36"
              color="#2C3454"
              secondaryColor="#E7E3DA"
            />
          </div>
        ) : days.length > 0 ? (
          <div className="lp-rail-wrap">
            <span className="lp-rail-btn" onClick={() => scrollRail(-1)}>
              ‹
            </span>
            <div className="lp-rail" ref={railRef}>
              {days.map((d, index) => (
                <div
                  key={index}
                  className={`lp-day-chip${d.day === selectedDay ? " active" : ""}`}
                  onClick={() => setSelectedDay(d.day)}
                >
                  <div className="lp-day-chip-label">
                    {formatWeekday(d.day)}
                  </div>
                  <div className="lp-day-chip-date">
                    {formatShortDate(d.day)}
                  </div>
                </div>
              ))}
            </div>
            <span className="lp-rail-btn" onClick={() => scrollRail(1)}>
              ›
            </span>
          </div>
        ) : null}

        {isLessonLoading ? (
          <div className="lp-state">
            <Oval
              height="40"
              width="40"
              color="#2C3454"
              secondaryColor="#E7E3DA"
            />
          </div>
        ) : lessonPlans.length > 0 ? (
          <div className="lp-timeline">
            {lessonPlans.map((file, index) => (
              <div className="lp-entry" key={index}>
                <div className="lp-time-col">
                  <div className="lp-time-start">
                    {file?.start_time?.slice(0, 5)}
                  </div>
                  <div className="lp-time-end">
                    {file?.end_time?.slice(0, 5)}
                  </div>
                </div>
                <div className="lp-rail-col">
                  <span className="lp-dot" />
                  <span className="lp-dot-line" />
                </div>
                <div className="lp-entry-card">
                  <div className="lp-entry-top">
                    <span className="lp-unit-badge">
                      {initials(file?.unit)}
                    </span>
                    <div>
                      <div className="lp-topic">{file?.topic}</div>
                      <div className="lp-unit">{file?.unit}</div>
                    </div>
                  </div>
                  {file?.description && (
                    <p className="lp-description">{file.description}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="lp-state">
            <div className="lp-empty-icon">✦</div>
            <p className="lp-empty-title">No lessons scheduled</p>
            <p className="lp-empty-sub">
              Pick another day to see its lesson plan.
            </p>
          </div>
        )}
      </div>
    </Card>
  );
};

export default LessonPlanSection;
